import * as actionTypes from '../actionsTypes'
import axios from '../../../http-config'
import swal from 'sweetalert'

export const fetchClusterDataStart = () => {
    return({
        type  : actionTypes.FETCH_CLUSTERLISTING_START,
        loading: false
    })
}

export const fetchClusterDataSuccess = (response) => {
    return ({
        type    : actionTypes.FETCH_CLUSTERLISTING_SUCCESS,
        payload : response.data.ulbs,
        totalCount : response.totalCount,
        loading:true
    })
}
// getting user data for cluster by get api
export const fetchGetClusterDataSuccess = (response) => {
    return ({
        type    : actionTypes.FETCH_CLUSTERLISTINGGET_SUCCESS,
        payload : response.data,
        totalCountUser : response.totalCount,
        loadingUser:true
    })
}


export const fetchClusterDataFail = (error) => {
    return({
        type   : actionTypes.FETCH_CLUSTERLISTING_FAIL,
        error  : error,
        loading:true
    })
}

export const fetchClusterData = (payload) => {
    // removed page and limit from api
    let  url =payload.limit == undefined?  `ulb/cluster-ulb`:`ulb/cluster-ulb?ulbName=${payload.searchQuery}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}`
    const token = payload.token
    return (dispatch) => {
        dispatch(fetchClusterDataStart())
        axios({
            method  : 'get',
            url     :url,
            headers : {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            dispatch(fetchClusterDataSuccess(response.data))
        })
        .catch((err) => {
            dispatch(fetchClusterDataFail(err))
        })
    }
}
// calling get api for prefield edit user on cluster mangement
export const getDataForEditUser =(payload)=>{
    const url =  `ulb/get-Cluster-Users?ULBId=${payload.ULBId}`
    const token = payload.token
    return (dispatch) => {
        dispatch(fetchClusterDataStart())
        axios({
            method  : 'get',
            url     :url,
            headers : {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            dispatch(fetchGetClusterDataSuccess(response.data))
            dispatch(fetchClusterData({token:payload.token , limit:10, page:1,searchQuery:'', sortName:'', sortValue:''}));
        })
        .catch((err) => {
            dispatch(fetchClusterDataFail(err))
        })
    }
}
export const addUserCluster = (payload, SubmitProp) => {
    let token = SubmitProp.token
    return (dispatch)=> {
        dispatch(fetchClusterDataStart())
        let url = 'user/create-cluster-user'
        axios.post(url, payload, {headers: {
            "Authorization":`Bearer ${token}`
        }})
        .then((response) => {
            const fetchedResponse = response.data.success;
            if(fetchedResponse === true){
                fetchedResponse && swal({
                    title: "Data Added",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                //props.history.push('/cluster-management')
            }
            dispatch(fetchClusterData({token:SubmitProp.token ,searchQuery:'', sortName:'', sortValue:''}));
        })  
        .catch((err)=>{
            swal({icon : "error" , title : err.response.data.error[0]["message"]})
            dispatch(fetchClusterData({token:SubmitProp.token , searchQuery:'', sortName:'', sortValue:''}));
        })
    }
    // (err) => {
    //     .catch(error => {
    //         dispatch(fetchClusterDataFail(error)) 
    //         console.log(error)          
    //     })
    // }
}

export const editUserCluster = (payload,SubmitProp) => {
    const id = SubmitProp.id
    return dispatch => {
        dispatch(fetchClusterDataStart());
        let url = 'user/update_cluster-user';
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${SubmitProp.token}`
        }})
        .then(response => {
          
            const fetchedResponse = response.data.success;
            if(fetchedResponse ===true){
                fetchedResponse && swal({
                    title: "You have Successfully edited the data!!!",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
            }
            dispatch(getDataForEditUser({token:SubmitProp.token , ULBId:payload.userULBId }))
             
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})   
            dispatch(getDataForEditUser({token:SubmitProp.token , ULBId:payload.userULBId }))       
        })
        .catch(err => {
            dispatch(fetchClusterDataFail(err))
            dispatch(getDataForEditUser({token:SubmitProp.token , ULBId:payload.userULBId }))
        })
    }
}

export const addClusterUlbData = (payload,SubmitProp, props, t)=>{
    let token=SubmitProp.token
    return (dispatch)=>{
        dispatch(fetchClusterDataStart())

        let url = 'ulb/cluster';
        axios.post(url, payload,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then((response) => {
            
            const fetchedResponse = response.data.success;
            if(fetchedResponse === true){
                fetchedResponse && swal({
                    title: t("disposalAdd"),
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                props.history.push('/cluster-management')
            }
            dispatch(fetchClusterData({token:SubmitProp.token , limit:10, page:1,searchQuery:'', sortName:'', sortValue:''}));
                
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})           
        }).catch(error => {
            dispatch(fetchClusterDataFail(error))           
        })
        
    }
}
export const editClusterUlbData = (payload,SubmitProp, props) => {
    const id = SubmitProp.id
    return dispatch => {
        dispatch(fetchClusterDataStart());
        let url = 'ulb/cluster';
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${SubmitProp.token}`
        }})
        .then(response => {
          
            const fetchedResponse = response.data.success;
            if(fetchedResponse ===true){
                fetchedResponse && swal({
                    title: "You have Successfully edited the data!!!",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  props.history.push('/cluster-management')
            }
            dispatch(fetchClusterData({token:SubmitProp.token , searchQuery:'',sortName:'', sortValue:'', }))
             
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})          
        })
        .catch(err => {
            dispatch(fetchClusterDataFail(err))
        })
    }
}
export const searchClusterName=(payload)=>{
    return dispatch =>{
        dispatch(fetchClusterDataStart());
        const url =`ulb/cluster-ulb?ulbName=${payload.searchQuery}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            response && response.data && response.data.data &&
            response.data.data && 
            response.data.data.length == 0 && 
            swal("No Records Found !", {
                icon: "warning",
              });
            dispatch(fetchClusterDataSuccess(response.data));
        }).catch(err=>{
            dispatch(fetchClusterDataFail(err));
        })
    }
}

export const deleteClusterUlbData = (payload, t) => {
    let token = localStorage.getItem('token');
    return (dispatch) => {
        dispatch(fetchClusterDataStart())
        const url =  '/ulb/cluster'
        axios.delete(url , { data : payload, headers : {   "Authorization":`Bearer ${token}`} })
        .then((response) => {
            dispatch(fetchClusterData({token:token , searchQuery:'', sortName:'', sortValue:'', }))
            swal({
                title: t("ulbDeleteErr5"),
                icon: "success",
            })
            
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
        })
    }
}


export const bulkCluster =(payload, formData)=>{

    let token = payload.token
    return dispatch => {
        dispatch(fetchClusterDataStart())
        const url = 'ulb/cluster-ulb/bulk'

        axios.post(url,formData,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            if(response){
                const fetchedLoadsResponse = response.data.success;
                fetchedLoadsResponse && swal({
                    title: "Data imported successfully!",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  .then((bulk) => {
                    if (bulk) {
                        dispatch(fetchClusterData({token:token , searchQuery:'', sortName:'', sortValue:'', }))
                    } 
                  });
            }
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})    
        })
        .catch(err => {
            dispatch(fetchClusterDataFail(err));
        })

    }
}